var map = {
	"./Stat_close_combat.png": "599d",
	"./Stat_energy.png": "78af",
	"./Stat_fire_arms.png": "3aee",
	"./Stat_hacking.png": "b6f1",
	"./Stat_lvl.png": "f639",
	"./Stat_trickery.png": "e660",
	"./Stat_xp.png": "d5b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22c8";